import styled from "styled-components";
import { Link } from 'react-router-dom';

export const Page = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  min-height: 100vh;
  max-width: 480px;
  width: 100%;
  margin: 0 auto;
  padding: 0 7%;
`;

export const ContentWrap = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

export const InputWrap = styled.div`
  width: 100%;
  max-width: 400px;
  height: 50px;
  display: flex;
  align-items: center;
  border-radius: 14px;
  background-color: #F5F5F5;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.1);
  margin-top: 2vh;
  padding: 0 20px;
  gap: 12px;

  input {
    flex: 1;
    font-size: 15px;
    border: none;
    outline: none;
    background-color: transparent;
  }

  svg {
    font-size: 20px;
    color: #717171ff;
    flex-shrink: 0;
  }
`;

export const LogoWrap = styled.div`
  margin-bottom: 3vh;
  display: flex;
  justify-content: center;
  align-items: center;

  img {
    width: 150px;
    height: auto;
  }

  h1 {
    color: #1FBC70;
    font-size: 28px;
    font-weight: bold;
  }
`;

export const ErrorMessage = styled.div`
  margin-top: 1vh;
  color: #FC324A;
  font-size: 12px;
  text-align: center;
`;

export const BottomButton = styled.button`
  width: 100%;
  max-width: 400px;
  height: 50px;
  border: none;
  font-weight: 700;
  font-size: 15px;
  background-color: #1FBC70;
  border-radius: 14px;
  color: white;
  cursor: pointer;
  margin-top: 3vh;

  &:hover {
    background-color: #18a860;
  }

  &:active {
    background-color: #159150;
  }
`;

export const GuestButton = styled.button`
  width: 100%;
  max-width: 400px;
  height: 50px;
  border: 1.5px solid #e0e0e0;
  font-weight: 600;
  font-size: 15px;
  background-color: transparent;
  border-radius: 14px;
  color: #888;
  cursor: pointer;
  margin-top: 12px;
  transition: border-color 0.15s, color 0.15s, background-color 0.15s;

  &:hover {
    border-color: #1fbc70;
    color: #1fbc70;
    background-color: #f0fdf7;
  }
`;

export const Bottom = styled.div`
  margin-top: 3vh;
  display: flex;
  justify-content: center;
  align-items: center;
  padding-left: 20px;
`;

export const StyledLink = styled(Link)`
  color: #666;
  text-decoration: none;
  font-size: 12px;
  display: inline-block;

  &::after {
    content: '|';
    color: #666;
    margin: 0 8px 0 12px;
  }

  &:last-child::after {
    content: '';
  }

  &:hover {
    color: #333;
  }
`;
